import { render } from "./NavigationLinks.vue?vue&type=template&id=87bd44d4"
import script from "./NavigationLinks.vue?vue&type=script&lang=js"
export * from "./NavigationLinks.vue?vue&type=script&lang=js"

import "./NavigationLinks.vue?vue&type=style&index=0&id=87bd44d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__